import React from 'react';
import {Box, CircularProgress} from "@mui/material";
import CCOContainer from "./CCOContainer";

interface Props {
    noContainer?: boolean,
    height?: number,
    customStyle?: any
}

const LoadingSpinner = (props: Props) => {
    const height = (props.height ? props.height : 300) + "px";

    function renderSpinner() {
        return <Box
            sx={{display: 'flex', justifyContent: 'center', marginTop: '50px', height: height, ...props.customStyle}}>
            <CircularProgress/>
        </Box>
    }
    if (props.noContainer) {
        return renderSpinner();
    } else {
        return <CCOContainer>{renderSpinner()}</CCOContainer>
    }
}

export default LoadingSpinner;
